import { faAngleLeft, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import Blue_border_button from "../../../../common_components/common_btn/blue_border_button/Blue_border_button";
import "./Applications_Section.css";
import Internship_Program from "./internship-program/Internship_Program";
import Study_Program from "./study-program/Study_Program";
import Application_Internship_Program from "./application-internship-program/Application_Internship_Program";
import Application_Study_Program from "./application-study-program/Application_Study_Program";
import { useDispatch, useSelector } from "react-redux";
import { GetAll } from "../../../../../features/admin/student/studentapplication/Slice";
import { GetAllInternship } from "../../../../../features/admin/student/hotelapplication/Slice";

const Applications_Section = () => {
  const dispatch = useDispatch();
  const collegelist = useSelector(
    (state) => state.studentapplication.studentapplications
  );
  const hotellist = useSelector(
    (state) => state.studentapplication.hotelapplications
  );
  console.log(hotellist, "hotellisthotellist");

  useEffect(() => {
    dispatch(GetAll());
    dispatch(GetAllInternship());
  }, [dispatch]);

  const [openUni, setOpenUni] = useState(false);
  const [openCourse, setOpenCourse] = useState(false);
  const [activeTab, setActiveTab] = useState("study");
  const [view, setView] = useState("programs");
  const [showHeader, setShowHeader] = useState(true);
  const handleCourseSelect = (value) => {
    console.log(value); // apply course / department logic here
    setOpenCourse(false);
  };

  const uniRef = useRef(null);
  const courseRef = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (uniRef.current && !uniRef.current.contains(e.target))
        setOpenUni(false);
      if (courseRef.current && !courseRef.current.contains(e.target))
        setOpenCourse(false);
    };

    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  return (
    <section className="application_section">
      {/* ================= NORMAL PROGRAM VIEW ================= */}
      {view === "programs" && (
        <>
          {/* HEADER (search + filters + toggle); hide when details view is open */}
          {showHeader && (
            <>
              <div className="serach_header">
                {/* Search */}
                <InputGroup className="search_box">
                  <Form.Control
                    placeholder="Search Program"
                    className="search_input"
                  />
                  <div className="search_btn">
                    <i className="fa fa-search"></i>
                  </div>
                </InputGroup>

                {/* FIRST DROPDOWN */}
                <div className="dropdown_wrapper" ref={uniRef}>
                  <button
                    className="dark_btn"
                    onClick={() => {
                      setOpenUni(!openUni);
                      setOpenCourse(false);
                    }}
                  >
                    {activeTab === "study" ? "Universities" : "Countries"}
                    <div className="aap_icon_holder">
                      <FontAwesomeIcon
                        icon={faChevronDown}
                        className={`dropdown_icon ${openUni ? "rotate" : ""}`}
                      />
                    </div>
                  </button>

                  {openUni && (
                    <div className="custom_dropdown">
                      {activeTab === "study" ? (
                        <>
                          <button className="dropdown_item">
                            French Universities
                          </button>
                          <button className="dropdown_item">
                            Canadian Universities
                          </button>
                        </>
                      ) : (
                        <>
                          <button className="dropdown_item">
                            Interning in France
                          </button>
                          <button className="dropdown_item">
                            Interning in Mauritius
                          </button>
                        </>
                      )}
                    </div>
                  )}
                </div>

                {/* SECOND DROPDOWN */}
                <div className="dropdown_wrapper" ref={courseRef}>
                  <button
                    className="dark_btn"
                    onClick={() => {
                      setOpenCourse(!openCourse);
                      setOpenUni(false);
                    }}
                  >
                    {activeTab === "study" ? "Courses" : "Departments"}
                    <div className="aap_icon_holder">
                      <FontAwesomeIcon
                        icon={faChevronDown}
                        className={`dropdown_icon ${
                          openCourse ? "rotate" : ""
                        }`}
                      />
                    </div>
                  </button>

                  {openCourse && (
                    <div className="custom_dropdown">
                      {activeTab === "study" ? (
                        <>
                          <button
                            className="dropdown_item"
                            onClick={() => handleCourseSelect("MBA")}
                          >
                            MBA
                          </button>
                          <button
                            className="dropdown_item"
                            onClick={() => handleCourseSelect("MIM")}
                          >
                            MIM
                          </button>
                          <button
                            className="dropdown_item"
                            onClick={() => handleCourseSelect("MIR")}
                          >
                            MIR
                          </button>
                        </>
                      ) : (
                        <>
                          <button
                            className="dropdown_item"
                            onClick={() => handleCourseSelect("Hospitality")}
                          >
                            Hospitality
                          </button>
                          <button
                            className="dropdown_item"
                            onClick={() =>
                              handleCourseSelect("International Relations")
                            }
                          >
                            International Relations
                          </button>
                        </>
                      )}
                    </div>
                  )}
                </div>

                {/* MY APPLICATIONS BUTTON */}
                <div className="btn_holder">
                  <Blue_border_button
                    button_text="My Applications"
                    onClick={() => setView("myApplications")}
                  />
                </div>
              </div>

              {/* Toggle Buttons */}
              <div className="program_toggle">
                <Button
                  className={`program_btn ${
                    activeTab === "study" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("study")}
                >
                  Study Program
                </Button>

                <Button
                  className={`program_btn ${
                    activeTab === "internship" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("internship")}
                >
                  Internship Program
                </Button>
              </div>
            </>
          )}

          {/* Render Programs */}
          {activeTab === "study" && (
            <>
              <div className="study_tab_holder">
                <Study_Program
                  onShowDetails={() => setShowHeader(false)}
                  onBackToList={() => setShowHeader(true)}
                />
              </div>
            </>
          )}
          {activeTab === "internship" && (
            <Internship_Program
              onShowDetails={() => setShowHeader(false)}
              onBackToList={() => setShowHeader(true)}
            />
          )}
        </>
      )}

      {/* ================= MY APPLICATIONS VIEW ================= */}
      {/* MY APPLICATIONS VIEW ================= */}
      {view === "myApplications" && (
        <div className="my_applications_section">
          {/* TOP HEADER */}
          <div className="my_applications_header">
            {/* Back Button */}
            <Button
              className="dark_btn back_btn"
              onClick={() => setView("programs")}
            >
              <div className="back_icon_holder">
                <FontAwesomeIcon icon={faAngleLeft} />
              </div>
              Back
            </Button>

            {/* Center Tabs */}
            <div className="program_toggle">
              <Button
                className={`program_btn ${
                  activeTab === "study" ? "active" : ""
                }`}
                onClick={() => setActiveTab("study")}
              >
                Study Program
              </Button>

              <Button
                className={`program_btn ${
                  activeTab === "internship" ? "active" : ""
                }`}
                onClick={() => setActiveTab("internship")}
              >
                Internship Program
              </Button>
            </div>

            {/* ❌ My Applications Button REMOVED */}
            {/* 
      <div className="right_btn">
        <Blue_border_button button_text="My Applications" />
      </div>
      */}
          </div>

          {/* CONTENT */}
          <div className="My_Applications">
            {activeTab === "study" && (
              <Application_Study_Program isMyApplications />
            )}
            {activeTab === "internship" && (
              <Application_Internship_Program isMyApplications />
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default Applications_Section;
